import _ from 'lodash'

export const makeReducer = (handlers, initialState) => (state = initialState, action) => {
  const handler = handlers[action.type]
  return _.isFunction(handler) ? handler(state, action) : state
}